import React, { useEffect, useContext } from "react";
import { UserContext } from "./auth/userContext";
import Routers from "./routes";
import PermissionChecker from "./auth/RolePermissionChecker";
import AdminDashboard from "./pages/admin/dashboard";
import JudgeLayout from "./layout/judgeLayout";
import MemberLayout from "./layout/memberLayout";
import GuestLayout from "./layout/guestLayout";
import LoadingFrame from "./layout/loadingFrame";
import AdminLayout from "./layout/adminLayout";
export default function ContentLayout(appProps) {
  const userContext = useContext(UserContext);

  useEffect(() => {
    console.log(userContext.pageId);
    userContext.addPageId();
  }, []);
  const contentLayout = (key) => {
    var address = window.location.pathname;
    if (appProps.isLoading) {
      return <LoadingFrame loading={true}></LoadingFrame>;
    }

    if (address == "/") {
      return <Routers {...appProps} />;
    }

    if (address == "/login" || address == "/register") {
      return (
        <GuestLayout>
          <Routers {...appProps} />
        </GuestLayout>
      );
    }

    // if (address.includes("judge")) {
    //   return (
    //     <JudgeLayout {...appProps}>
    //       <Routers {...appProps} />
    //     </JudgeLayout>
    //   );
    // }

    if (address.includes("member")) {
      return (
        <MemberLayout {...appProps}>
          <Routers {...appProps} />
        </MemberLayout>
      );
    }
    if (appProps.isAuthenticated && address == "/404") {
      return (
        <MemberLayout {...appProps}>
          <Routers {...appProps} />
        </MemberLayout>
      );
    }

    if (address.includes("admin")) {
      return (
        <AdminLayout>
          <Routers {...appProps} />
        </AdminLayout>
      );
    }

    if (!appProps.isAuthenticated || address.includes("judge/profile")) {
      return (
        <GuestLayout>
          {" "}
          <Routers {...appProps} />
        </GuestLayout>
      );
    }
    return <Routers {...appProps} />;
  };
  return <div>{contentLayout(userContext.pageId)}</div>;
}
